import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { priceHighlights } from '../data/mockData';

export const PriceHighlights = () => {
  return (
    <section id="prices" className="section-padding bg-coconut">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="section-title mb-4">
            Preise
          </h2>
          <p className="section-subtitle">
            Transparente Preise für erstklassige Leistungen
          </p>
        </div>

        {/* Price Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {priceHighlights.map((category, index) => (
            <div key={index} className="price-card">
              <h3 className="text-xl font-bold mb-6 text-center pb-4 border-b border-gray-200">
                {category.category}
              </h3>
              <ul className="space-y-4">
                {category.services.map((service, idx) => (
                  <li key={idx} className="price-item">
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900 mb-1">
                        {service.name}
                      </div>
                      <div className="flex items-center text-sm text-gray-600">
                        <Clock className="w-3 h-3 mr-1" />
                        <span>{service.duration}</span>
                      </div>
                    </div>
                    <div className="font-bold text-accent text-lg">
                      {service.price}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA to Full Pricelist */}
        <div className="text-center">
          <Link 
            to="/pricelist"
            className="btn-primary inline-flex items-center group"
          >
            <span>Vollständige Preisliste ansehen</span>
            <ArrowRight className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};
